module.exports = __webpack_public_path__ + "img/si_get.09afdd2.png";